import React, { useState, useEffect } from 'react';

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, [statusFilter]);

  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      let url = `https://d4unaturally.com/api/admin-orders.php?limit=50&offset=0`;
      if (statusFilter) url += `&status=${statusFilter}`;

      const response = await fetch(url, { 
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP! statut: ${response.status}`);
      }

      const data = await response.json();
      console.log('Données reçues:', data); // Debug

      if (data.success) {
        // S'assurer que orders est toujours un tableau
        setOrders(Array.isArray(data.orders) ? data.orders : []);
      } else {
        throw new Error(data.error || data.message || 'Erreur inconnue');
      }
    } catch (error) {
      console.error('Erreur fetch commandes:', error);
      setError(error.message);
      // En cas d'erreur, s'assurer que orders est un tableau vide
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour afficher les produits
  const renderItems = (items) => {
    if (!items || !Array.isArray(items) || items.length === 0) {
      return <span className="text-gray-400">Aucun produit</span>;
    }
    
    return items.map((item, idx) => (
      <div key={idx} className="mb-1">
        {item.product_name || item.name} x{item.quantity}
        {item.price && <span className="text-gray-500 ml-2">({item.price} DH)</span>}
      </div>
    ));
  };

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-serif font-light text-gray-900 mb-4">Gestion des Commandes</h2>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
          Erreur: {error}
          <button 
            onClick={fetchOrders}
            className="ml-4 bg-red-600 text-white px-3 py-1 rounded text-sm hover:bg-red-700"
          >
            Réessayer
          </button>
        </div>
      )}

      <div className="mb-4 flex items-center space-x-4">
        <label className="text-gray-700 font-medium">Filtrer par statut:</label>
        <select 
          value={statusFilter} 
          onChange={e => setStatusFilter(e.target.value)}
          className="px-4 py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Tous</option>
          <option value="paid">Payées</option>
          <option value="pending">En attente</option>
          <option value="failed">Échouées</option>
        </select>
        
        <button 
          onClick={fetchOrders}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Actualiser
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-500">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
          <div>Chargement des commandes...</div>
        </div>
      ) : (
        // Toujours s'assurer que orders est défini avant d'accéder à .length
        (!orders || orders.length === 0) ? (
          <div className="text-center py-12 text-gray-400 border-2 border-dashed border-gray-200 rounded-2xl">
            Aucune commande trouvée.
            {statusFilter && (
              <div className="mt-2">
                <button 
                  onClick={() => setStatusFilter('')}
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  Voir toutes les commandes
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="overflow-x-auto bg-white rounded-2xl shadow-lg border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Référence</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Client</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Email</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Montant</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Statut</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-gray-700 uppercase tracking-wider">Produits</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {orders.map(order => (
                  <tr key={order.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm font-mono text-gray-900">#{order.id}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 font-medium">{order.reference}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      {order.customer_name || `Client ${order.customer_id || 'N/A'}`}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900">{order.customer_email || 'N/A'}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 font-medium">{order.total_amount || 0} DH</td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        order.payment_status === 'paid' 
                          ? 'bg-green-100 text-green-800' 
                          : order.payment_status === 'pending'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {order.payment_status || 'inconnu'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500">
                      {order.created_at ? new Date(order.created_at).toLocaleDateString('fr-FR') : 'N/A'}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">
                      {renderItems(order.items)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
};

export default AdminOrders;